const CONFIG = (window.NAIGRU && window.NAIGRU.config && window.NAIGRU.config.analytics) || {};

export const ym = (action, value, ...other) => {
    if (!CONFIG.yandex_metrika_enabled || !CONFIG.yandex_metrika_id || !window.ym) {
        return false;
    }

    window.ym(CONFIG.yandex_metrika_id, action, value, ...other);
};
